module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isSsoFlag) ? _c('order-content', {
    attrs: {
      "buttonName": "下一步",
      "coupons": _vm.coupons,
      "selectCoupon": _vm.selectCoupon,
      "productInfo": _vm.productInfo,
      "showpromotion": true,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.orderSubmit,
      "updateSelectCoupon": _vm.updateSelectCoupon
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "item-link item-content",
    on: {
      "click": _vm.goToMyCoupons
    }
  }, [_c('div', {
    staticClass: "item-inner item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("优　惠　券")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.coupons.value.length === 0) ? _c('span', [_vm._v("无")]) : (_vm.selectCoupon) ? _c('span', [(_vm.selectCoupon.label.indexOf('折券') !== -1) ? _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label) + "..")]) : _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label))]), _vm._v(" "), (_vm.selectCoupon.type !== 0 && _vm.selectCoupon.type !== 6) ? _c('span', [_vm._v(_vm._s(_vm._f("currencyStyle")(_vm.selectCoupon.value)))]) : _vm._e()]) : _c('span', [_vm._v("共" + _vm._s(_vm.coupons.value.length) + "张")])])])])])])])]) : _c('order-content', {
    attrs: {
      "buttonName": "提交审核",
      "coupons": _vm.coupons,
      "showpromotion": true,
      "selectCoupon": _vm.selectCoupon,
      "productInfo": _vm.productInfo,
      "showButton": _vm.showButton
    },
    on: {
      "response": _vm.checkSubmit,
      "updateSelectCoupon": _vm.updateSelectCoupon
    }
  }, [_c('div', {
    staticClass: "list-block media-list",
    staticStyle: {
      "margin-top": "5px",
      "margin-bottom": "0"
    }
  }, [_c('ul', [_c('li', [_c('a', {
    staticClass: "item-link item-content",
    on: {
      "click": _vm.goToMyCoupons
    }
  }, [_c('div', {
    staticClass: "item-inner item-title-row"
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("优　惠　券")]), _vm._v(" "), _c('div', {
    staticClass: "item-after"
  }, [(_vm.coupons.value.length === 0) ? _c('span', [_vm._v("无")]) : (_vm.selectCoupon) ? _c('span', [_vm._v(_vm._s(_vm.selectCoupon.label)), (_vm.selectCoupon.type !== 0 && _vm.selectCoupon.type !== 6) ? _c('span', [_vm._v(_vm._s(_vm._f("currencyStyle")(_vm.selectCoupon.value)))]) : _vm._e()]) : _c('span', [_vm._v("共" + _vm._s(_vm.coupons.value.length) + "张")])])])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a1920d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./script/loaders/emktVueLoader.js!./src/views/Order/OrderContentConfirm.vue
// module id = 1657
// module chunks = 8